import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import InterviewPaperBriefPage from '../../features/interview/components/InterviewPaperBriefPage';

const InterviewPaperBriefPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <InterviewPaperBriefPage />
  </ProtectedRoute>
);

export default InterviewPaperBriefPageRoute;
